
import { Subject } from 'rxjs';

const subject = new Subject();

export const siteUpdateService = {
    sendSite: site => subject.next(site),
    clearSite: () => subject.next(),
    getSite: () => subject.asObservable()
};